module.exports = __webpack_public_path__ + "static/media/YF107_1.59b6b60e.jpg";